import { graphql } from "@/graphql/generated";
import { AddMunicipalPropertyYearMutation, AddMunicipalPropertyYearMutationVariables } from "@/graphql/generated/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export const ADD_MUNICIPAL_PROPERTY_YEAR_MUTATION_DOCUMENT: TypedDocumentNode<AddMunicipalPropertyYearMutation, AddMunicipalPropertyYearMutationVariables> = graphql(/* GraphQL */ `
    mutation AddMunicipalPropertyYear($input: AddMunicipalPropertyYearInput!) {
      addMunicipalPropertyYear(input: $input) { id }
    }
  `);
